import React from 'react';

const SmsOutboundTable = ({
	items = [],
	sortBy,
	sortOrder,
	onSort,
	onViewDetails,
}) => {
	const formatDate = (dateString) => {
		if (!dateString) return '-';
		return dateString;
	};

	const getSortIcon = (column) => {
		if (sortBy !== column) {
			return <i className="bi bi-arrow-down-up text-muted ms-1" />;
		}
		return sortOrder === 'asc' ? (
			<i className="bi bi-arrow-up ms-1" />
		) : (
			<i className="bi bi-arrow-down ms-1" />
		);
	};

	const getStatusBadge = (status) => {
		const badges = {
			pending: 'bg-warning',
			sent: 'bg-success',
			sent_digest: 'bg-info',
			failed: 'bg-danger',
		};
		const labels = {
			pending: 'Pending',
			sent: 'Sent',
			sent_digest: 'Digest',
			failed: 'Failed',
		};

		return (
			<span className={`badge ${badges[status] || 'bg-secondary'}`}>
				{labels[status] || status}
			</span>
		);
	};

	return (
		<div className="table-responsive">
			<table className="table table-hover mb-0">
				<thead className="table-light">
					<tr>
						<th
							style={{ cursor: 'pointer' }}
							onClick={() => onSort('created_at')}
						>
							When {getSortIcon('created_at')}
						</th>
						<th>Recipient</th>
						<th>Property / Class</th>
						<th
							style={{ cursor: 'pointer' }}
							onClick={() => onSort('template_key')}
						>
							Template {getSortIcon('template_key')}
						</th>
						<th style={{ cursor: 'pointer' }} onClick={() => onSort('tier')}>
							Tier {getSortIcon('tier')}
						</th>
						<th style={{ cursor: 'pointer' }} onClick={() => onSort('status')}>
							Status {getSortIcon('status')}
						</th>
						<th>Twilio SID</th>
						<th className="text-end">Actions</th>
					</tr>
				</thead>
				<tbody>
					{items.map((row) => (
						<tr key={row.id}>
							<td>
								<small>{formatDate(row.sent_at || row.created_at)}</small>
							</td>
							<td>
								{row.user ? (
									<div>
										<div className="fw-medium">{row.user.name}</div>
										<small className="text-muted">
											{row.user.phone || row.user.email}
										</small>
									</div>
								) : (
									<span className="text-muted">Unassigned</span>
								)}
							</td>
							<td>
								{row.property ? (
									<div>
										<div
											className="text-truncate"
											style={{ maxWidth: '220px' }}
										>
											<i className="bi bi-building me-1" />
											{row.property.address}
										</div>
										<small className="text-muted">{row.class}</small>
									</div>
								) : (
									<small className="text-muted">{row.class || '—'}</small>
								)}
							</td>
							<td>
								<code>{row.template_key}</code>
							</td>
							<td>
								<span className="badge bg-secondary">{row.tier}</span>
							</td>
							<td>{getStatusBadge(row.status)}</td>
							<td>
								<small>
									<code>{row.twilio_sid || '—'}</code>
								</small>
							</td>
							<td className="text-end">
								<button
									className="btn btn-sm btn-primary"
									onClick={() => onViewDetails(row)}
									title="View Details"
								>
									<i className="bi bi-eye" />
								</button>
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default SmsOutboundTable;
